import {
  PHOTO_UPLOAD_RECEIVE_IS_UPLOADING,
  PHOTO_UPLOAD_RECEIVE_UPLOAD_ERROR_MSG,
  PHOTO_UPLOAD_RECEIVE_NEW_IMAGES,
  PHOTO_UPLOAD_DELETE_IMAGE,
  PHOTO_UPLOAD_RESET_STATE,
} from '../../actions/photoUpload';

export const initialState = {
  isUploading: false,
  errorMsg: '',
  images: [],
};

export default (
  state = initialState,
  { type, data: { isUploading, errorMsg, images, filename } = {} } = {},
) => {
  switch (type) {
    case PHOTO_UPLOAD_RECEIVE_IS_UPLOADING:
      return {
        ...state,
        errorMsg: '',
        isUploading,
      };

    case PHOTO_UPLOAD_RECEIVE_UPLOAD_ERROR_MSG:
      return {
        ...state,
        errorMsg,
      };

    case PHOTO_UPLOAD_RECEIVE_NEW_IMAGES:
      return {
        ...state,
        errorMsg: '',
        images: [...state.images, ...images],
      };

    case PHOTO_UPLOAD_DELETE_IMAGE:
      return {
        ...state,
        errorMsg: '',
        images: state.images.filter((img) => img.filename !== filename),
      };

    case PHOTO_UPLOAD_RESET_STATE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};
